// extracted by mini-css-extract-plugin
module.exports = {"background":"X_dW","values":"X_d4"};